export const ADD_NOTIFICATION = 'ADD_NOTIFICATION'
export const REMOVE_NOTIFICATION = 'REMOVE_NOTIFICATION'
export const UPDATE_NOTIFICATION = 'UPDATE_NOTIFICATION'

export const ADD_MODAL = 'ADD_MODAL'
export const TOGGLE_MODAL = 'TOGGLE_MODAL'
export const REMOVE_MODAL = 'REMOVE_MODAL'
export const SET_FORCE_UPDATE = 'SET_FORCE_UPDATE'
export const SET_SIDEBAR_POSITION = 'SET_SIDEBAR_POSITION'
export const SET_GLOBAL_SEARCH = 'SET_GLOBAL_SEARCH'
export const LOAD_HELPY = 'LOAD_HELPY'
export const SET_ENABLED_FUNCTIONS = 'SET_ENABLED_FUNCTIONS'
export const SET_FIELD_BY_NAMESPACE_AND_PATH = 'SET_FIELD_BY_NAMESPACE_AND_PATH'
